import connectAsync from 'src/common/utils/connectAsync';
import { fetchMe } from 'src/common/actions/me';
import ResetPasswordRoute from './ResetPasswordRoute';

export default connectAsync([fetchMe])(ResetPasswordRoute);
